import React from 'react';
import _ from 'lodash';

import styles from './InactiveCategories.module.css';

const InactiveCategories = ({ categories }) => {
  const noCategories = _.size(categories) === 0;
  if (noCategories) return null;

  return (
    <div className={styles.container}>
      <h3>Inactive Categories</h3>
      <div className={styles.wrapper}>
        <ul className={styles.categories}>
          {_.map(categories, (category) => {
            const { id, name, children } = category;
            return (
              <li key={id}>
                <span className={styles.category}>{name}</span>
                {_.size(children) > 0 && (
                  <ul className={styles.subcategories}>
                    {_.map(children, (subcategory) => {
                      const { id: scId, name: scName } = subcategory;
                      return <li key={scId}>{scName}</li>;
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default InactiveCategories;
